export default __webpack_public_path__ + "static/media/sputnik.4369dd79.png";